import { create } from "zustand";

const useSidebarStore = create((set) => ({
  sidebar: {
    title: "",
    contents: null,
    type: "", // 'post' | 'product' | 'user'
  },
  setSidebar: ({ title, contents, type }) => {
    // type should be one of 'post', 'product', 'user'
    set({
      sidebar: {
        title,
        contents,
        type,
      },
    });
  },
  resetSidebar: () => {
    set({
      sidebar: {
        title: "",
        contents: null,
        type: "",
      },
    });
  },
}));

export default useSidebarStore;
